import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { useLenis } from "./lib/useLenis";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Results from "./pages/Results";
import { CookieNotice } from "./components/CookieNotice";

function App() {
  useLenis();

  return (
    <LanguageProvider>
      <div className="relative min-h-screen overflow-x-clip bg-ink font-sans text-zinc-100" data-testid="app-root">
        <div className="grain pointer-events-none fixed inset-0 z-[60]" />
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/risultati" element={<Results />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <CookieNotice />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0E131F", border: "1px solid rgba(255,255,255,0.08)", color: "#F4F4F5" } }} />
      </div>
    </LanguageProvider>
  );
}

export default App;
